module.exports = __webpack_public_path__ + "static/media/user_timestamps.f99dd4e0.png";